var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-full fixed h-full login flex justify-center items-center mdmax:relative",
    class: {
      'mdmax:h-screen': _vm.visibleState === 'forgot-password'
    }
  }, [!_vm.isMobile ? _c('div', {
    staticClass: "w-7/12 bg-white h-full"
  }, [_c('div', {
    staticClass: "polygon bg-neutral-600 h-full flex items-center flex-col justify-center gap-10"
  }, [_vm._m(0), _c('div', {
    staticClass: "w-full pr-15p"
  }, [_c('carousel', {
    attrs: {
      "options": _vm.carouselBannerOptions,
      "slides": _vm.slides
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn(_ref) {
        var item = _ref.item,
            index = _ref.index;
        return [_c('img', {
          staticClass: "inline-block mb-6",
          attrs: {
            "src": item.image,
            "id": 'image-' + index
          }
        }), _c('p', {
          staticClass: "w-3/5 mx-auto text-white"
        }, [_vm._v(_vm._s(item.description))])];
      }
    }], null, false, 1749293510)
  })], 1)])]) : _vm._e(), _c('div', {
    staticClass: "w-5/12 bg-white relative h-full mdmax:w-full"
  }, [_c('div', {
    staticClass: "px-36 py-20 flex flex-col justify-center h-full mdmax:px-10 mdmax:py-10"
  }, [_vm._m(1), _vm.visibleState === 'login' ? _c('div', {
    staticClass: "form mt-12 text-left"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Alamat Email",
      "placeholder": "Silahkan masukan alamat email",
      "error": _vm.errors['username']
    },
    on: {
      "enter": function enter($event) {
        return _vm.doLogin();
      }
    },
    model: {
      value: _vm.payload.username,
      callback: function callback($$v) {
        _vm.$set(_vm.payload, "username", $$v);
      },
      expression: "payload.username"
    }
  })], 1), _c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Password")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": _vm.typeInput,
      "placeholder": "Silahkan masukan password",
      "error": _vm.errors['password']
    },
    on: {
      "enter": function enter($event) {
        return _vm.doLogin();
      },
      "input": _vm.userIsTyping
    },
    model: {
      value: _vm.payload.password,
      callback: function callback($$v) {
        _vm.$set(_vm.payload, "password", $$v);
      },
      expression: "payload.password"
    }
  }), _vm.typeInput === 'password' && _vm.isTyping ? _c('img', {
    staticClass: "w-5 absolute right-4 top-1/2 transform -translate-y-1/2",
    attrs: {
      "src": require("@/assets/images/icons/open-eye.svg")
    },
    on: {
      "click": function click($event) {
        return _vm.showPassword(true);
      }
    }
  }) : _vm._e(), _vm.typeInput === 'text' && _vm.isTyping ? _c('img', {
    staticClass: "w-5 absolute right-4 top-1/2 transform -translate-y-1/2",
    attrs: {
      "src": require("@/assets/images/icons/close-eye.svg")
    },
    on: {
      "click": function click($event) {
        return _vm.showPassword(false);
      }
    }
  }) : _vm._e()], 1)]), _vm.loginAttempts >= 3 ? _c('div', {
    staticClass: "flex justify-end mb-4"
  }, [_c('Recaptcha', {
    on: {
      "success": function success($event) {
        return _vm.doLogin();
      }
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "flex justify-end mb-4"
  }, [_c('span', {
    staticClass: "text-primary-500 font-medium cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.switchTo('forgot-password');
      }
    }
  }, [_vm._v("Lupa password?")])]), _c('div', {
    staticClass: "login__form-submit"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.generalError ? _c('div', {
    staticClass: "text-system-error mb-3"
  }, [_vm._v(_vm._s(_vm.generalError))]) : _vm._e()]), _c('Button', {
    attrs: {
      "buttonText": "Login",
      "size": "full",
      "type": "amber"
    },
    on: {
      "action": function action($event) {
        return _vm.doLogin();
      }
    }
  })], 1), _c('div', {
    staticClass: "mt-3"
  }, [_c('LinkButton', {
    attrs: {
      "buttonText": "Registrasi Mitra Bisnis",
      "type": "amber",
      "url": "/registration",
      "linkType": "internal",
      "size": "full"
    }
  })], 1), _vm._m(2), _c('div', {
    staticClass: "mt-10 text-center"
  })]) : _vm._e(), _vm.visibleState === 'forgot-password' ? _c('div', {
    staticClass: "text-left"
  }, [_c('p', {
    staticClass: "text-3xl font-bold text-left mb-8 mt-12"
  }, [_vm._v("Lupa password?")]), _c('div', {
    staticClass: "mb-9"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Alamat Email",
      "placeholder": "Silahkan masukan alamat email",
      "error": _vm.resetError
    },
    on: {
      "enter": function enter($event) {
        return _vm.doReset();
      }
    },
    model: {
      value: _vm.resetPasswordPayload.email,
      callback: function callback($$v) {
        _vm.$set(_vm.resetPasswordPayload, "email", $$v);
      },
      expression: "resetPasswordPayload.email"
    }
  })], 1), _c('div', {
    staticClass: "mb-12"
  }, [_c('Button', {
    attrs: {
      "disabled": _vm.disabledReset,
      "buttonText": "Reset",
      "size": "full"
    },
    on: {
      "action": function action($event) {
        return _vm.doReset();
      }
    }
  })], 1), _c('div', {
    staticClass: "flex items-center justify-center"
  }, [_c('span', {
    staticClass: "text-primary-500 flex items-center gap-3 cursor-pointer font-medium",
    on: {
      "click": function click($event) {
        return _vm.switchTo('login');
      }
    }
  }, [_c('ArrowForward', {
    attrs: {
      "direction": "left",
      "color": "primary-500"
    }
  }), _vm._v("Kembali ke login")], 1)])]) : _vm._e()]), _vm._m(3)]), _c('Toast')], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex justify-center items-center pr-15p"
  }, [_c('img', {
    staticClass: "w-48",
    attrs: {
      "src": require("@/assets/images/logos/logo-white.png")
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "inline-block w-48",
    attrs: {
      "src": require("@/assets/images/logos/logo-color.png")
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "mt-4 text-sm"
  }, [_vm._v(" Dengan melanjutkan, Anda memahami dan menyetujui penggunaan informasi yang Anda kirimkan sesuai dengan "), _c('a', {
    staticClass: "inline-block text-primary-500 font-semibold",
    attrs: {
      "href": "https://www.linknau.id/syarat-ketentuan",
      "target": "_blank"
    }
  }, [_vm._v("Syarat & Ketentuan")]), _vm._v(" dan "), _c('a', {
    staticClass: "inline-block text-primary-500 font-semibold",
    attrs: {
      "href": "https://www.linknau.id/kebijakan-privasi",
      "target": "_blank"
    }
  }, [_vm._v("Kebijakan Privasi")]), _vm._v(". ")]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "absolute bottom-8 left-1/2 transform -translate-x-1/2 select-none"
  }, [_c('div', {
    staticClass: "flex items-center gap-3 px-4 py-2 bg-white border border-neutral-200 rounded-full shadow-sm hover:shadow-md transition-shadow duration-300 cursor-default"
  }, [_c('span', {
    staticClass: "text-[10px] font-bold tracking-[0.15em] text-neutral-400 mt-[2px]"
  }, [_vm._v(" Powered by ")]), _c('div', {
    staticClass: "w-px h-3 bg-neutral-300"
  }), _c('img', {
    staticClass: "h-8 w-auto object-contain",
    attrs: {
      "src": require("@/assets/images/logos/linknau-w-tag.png"),
      "alt": "Linknau"
    }
  })])]);
}]

export { render, staticRenderFns }